/**
 * Created by Ram on 3/10/2016.
 */

import React, { Component } from 'react';
import moment from 'moment'
import { MenuItem, Select } from "@material-ui/core"
import './style.css'

export default class AllCustomersInfo extends Component {

    componentDidUpdate() {
        this.searchInput.focus()
    }

    renderRows = (customers) => {
        return customers.map((customer) => {
            let activeSpan
            const creationTimeFormatted = moment(customer.creationTime).format('MMM D - YYYY')

            if (customer.state == "ACTIVE" ) {
                activeSpan = <span className="active-inactive active-color"></span>;
            } else {
                activeSpan = <span className="active-inactive inactive-color"></span>;
            }

            return (
                <li key={customer._id} onClick={() => this.props.handleSelectCustomer(customer._id)}>
                    <div className="col-sm-4">{customer.name}</div>
                    <div className="col-sm-2">{customer.type}</div>
                    <div className="col-sm-3">{creationTimeFormatted}</div>
                    <div className="col-sm-3">{activeSpan}</div>
                </li>
            )
        })
    }

    render () {
        const accountType = ['Production', 'POC', 'Prospect', 'Internal']
        const { customers, lookupState: { sortAsc } } = this.props;
        const arrow = sortAsc ? <span className='glyphicon glyphicon-triangle-bottom' title="Active" /> : <span className='glyphicon glyphicon-triangle-top' title="Inactive" />;

        return (
            <div className="mainDivBody container-fluid">
                <div className="dashboard-user-forms">
                    <div className="all-customers-search">
                        <label>Search</label>
                        <input
                            ref={(input) => this.searchInput = input }
                            type="search" 
                            className="form-control" 
                            id="firstName" 
                            placeholder="Search by company name or email" 
                            onChange={this.props.updateSearchState} 
                            value={this.props.lookupState.search}
                        />
                        <span className="glyphicon glyphicon-search"></span>
                        
                        <div className='select-inputs-wrapper'>
                            <label>Filter By</label>
                            <Select
                                className='account-type-select form-control'
                                name='accountType'
                                onChange={this.props.updateAccountTypeState}
                                placeholder='Select Account Type'
                                value={this.props.lookupState.accountType}
                            >
                                <MenuItem value='all'>
                                    All accounts
                                </MenuItem>
                                {accountType.map((type) => (
                                    <MenuItem key={type} value={type}>
                                        {type}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>

                        <button type="button" className="btn btn-primary btn-lg" onClick={this.props.handleCreateAccount}>Create Customer Account</button>
                    </div>

                    <ul className="display-all-customers">
                        <li className="cust-info-heading">
                            <div className="col-sm-4" id="organisationName" onClick={() => this.props.updateSortState('name')}>Customer { this.props.lookupState.sort === 'name' ? arrow : '' }</div>
                            <div className="col-sm-2" id="accountType" onClick={() => this.props.updateSortState('type')}>Type { this.props.lookupState.sort === 'type' ? arrow : '' }</div>
                            <div className="col-sm-3" id="creationTime" onClick={() => this.props.updateSortState('creationTime')}>Created { this.props.lookupState.sort === 'creationTime' ? arrow : '' }</div>
                            <div className="col-sm-3" id="state"><span onClick={() => this.props.updateSortState('state')}>Status {this.props.lookupState.sort === 'state' ? arrow : '' }</span><br />
                                <span id="show-delete-container">
                                    <input type="checkbox" id="showDelete" name="showDelete" onChange={this.props.updateShowDeleted} defaultChecked={this.props.lookupState.showDeleted} />
                                    <span className="display-inactive-customers">Show Inactive Customers</span>
                                </span>
                            </div>
                        </li>
                        { this.renderRows(customers) }
                    </ul>
                </div>
            </div>
        ); // return
    } // render
} // AllCustomersInfo
